import { cleanupId, generateUniqueId } from 'Utils/unique-id/uniqueId';
import { COLORS } from 'Components/utils/color/colors';
export const getTabsBackgroundClasses = (
  hasBackground: boolean = false,
  color: string = COLORS.PEARL,
) => (hasBackground ? `bg-${color} border-b-1 border-t-1 border-grey` : '');
export const getTabsMainId = (
  items: Array<{
    header: {
      title: string;
    };
    title?: string;
  }> = [],
) => {
  const list = items
    .filter(Boolean)
    .map(({ header, title }) => (header && cleanupId(header.title)) || (title && cleanupId(title)))
    .filter(Boolean);
  return generateUniqueId(list, 'tabs-');
};
export const getTabsItemIds = ({
  id,
  title,
  index,
  mainId,
}: {
  id: string;
  title: string;
  index: number;
  mainId: string;
}) => {
  const headerId = id || generateUniqueId([mainId, cleanupId(title), `${index}`], 'tabs-header-');
  const panelId = generateUniqueId(
    [mainId, cleanupId(title), id && `${id}`, `${index}`],
    'tabs-panel-',
  );
  return [headerId, panelId];
};
